export default "__VITE_ASSET__CuWG5BJW__"